var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamecard2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91769 18.6671H15.9177M9.91769 16.156H13.9177M10.1179 6.95603C10.1179 9.35603 13.7179 9.35603 13.7179 6.95603C13.7179 4.55603 10.1179 4.55603 10.1179 6.95603ZM15.9177 13.156C15.9177 8.8227 7.91769 8.8227 7.91769 13.156H15.9177ZM6.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V5C20.5 3.34315 19.1569 2 17.5 2H6.5C4.84315 2 3.5 3.34315 3.5 5V19C3.5 20.6569 4.84315 22 6.5 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamecard2);
export default __webpack_public_path__ + "static/media/namecard_2.d879e28ee685863ca150ce246c7a888f.svg";
export { ForwardRef as ReactComponent };